import React, { useState } from "react";
import { Modal, Button, Typography, Form, Row, Col } from "antd";
import Draggable from "react-draggable";
import { CloseOutlined } from "@ant-design/icons";
import { FormattedMessage } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import ChildrenAnimationWrapper from "../../../components/animations/ChildrenAnimationWrapper";
import AnimationChildWrapper from "../../../components/animations/AnimationChildWrapper";
import { InputItem } from "../../../components/forms/FormItems";
import { sendAsset } from "../../asset/assetSlice";
const { Title } = Typography;

const SendMail = (props) => {
  const { hide, visible, activeRecord, scope, branchId } = props;
  const dispatch = useDispatch();
  const [disabled, setDisabled] = useState(true);
  const { scopePrefix } = useSelector((state) => state.user);
  const loading = useSelector((state) => state.pendingActions["asset/send"]);
  const [form] = Form.useForm();

  const onCancel = () => {
    hide();
  };

  const onMouseOver = () => {
    setDisabled(false);
  };

  const onMouseOut = () => {
    setDisabled(true);
  };

  const onSubmit = async (values) => {
    const scopePre = branchId
      ? `/branches/${branchId}/${scope}`
      : `${scopePrefix}${scope}`;

    const params = {
      assetId: activeRecord.id,
      scope: scopePre,
      email: values.email,
    };
    // const params =
    //   mode === "edit"
    //     ? {
    //         id: activeRecord.id,
    //         allValues: values,
    //         scope: scopePre,
    //       }
    //     : {
    //         branchId: branch_id,
    //         id: id,
    //         assetName: file.fileName,
    //         file: file,
    //         params: values,
    //         resource,
    //       };
    const action = await dispatch(sendAsset(params));
    if (!action.error) {
      onCancel();
      form.resetFields();
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  // const scopePre = branchId
  //   ? `branches/${branchId}/${scope}`
  //   : `${scopePrefix}${scope}`;

  const layout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 18 },
  };

  return (
    <Modal
      closable={false}
      maskClosable={false}
      open={visible}
      footer={null}
      onCancel={hide}
      title={null}
      width={"fit-content"}
      destroyOnClose={true}
      modalRender={(modal) => (
        <Draggable disabled={disabled}>{modal}</Draggable>
      )}
    >
      <div>
        <div
          className="header"
          style={{
            width: "100%",
            cursor: "move",
            height: "50px",
            position: "absolute",
            left: "0",
            top: "0",
          }}
          onMouseOver={onMouseOver}
          onMouseOut={onMouseOut}
        >
          <Button
            style={{ position: "absolute", left: 10, top: 10 }}
            className="closeBtn"
            type="text"
            shape="circle"
            icon={<CloseOutlined />}
            onClick={onCancel}
          />
        </div>
        <Title
          style={{
            fontSize: "30px",
            fontWeight: 500,
            lineHeight: 1.27,
            color: "rgba(0, 0, 0, 0.85)",
            margin: "13px 0 40px 0 ",
            textAlign: "center",
          }}
        >
          <FormattedMessage id={`app.assets.email_sending`} />
        </Title>
        <Form
          {...layout}
          onFinish={onSubmit}
          onFinishFailed={onFinishFailed}
          form={form}
          style={{
            padding: "0 56px 0px 56px",
            width: "600px",
          }}
        >
          <ChildrenAnimationWrapper>
            <Row>
              <Col key={1} span={24} style={{ padding: "0 20px" }}>
                <AnimationChildWrapper key={2} itemKey={2}>
                  <InputItem
                    name={"email"}
                    category={"assets"}
                    required={true}
                    email={true}
                  />
                </AnimationChildWrapper>
              </Col>
              <Row style={{ width: "100%" }}>
                <div
                  style={{
                    alignItems: "center",
                    justifyContent: "center",
                    display: "flex",
                    width: "100%",
                  }}
                >
                  <Form.Item wrapperCol={{ span: 24 }}>
                    <Button
                      style={{ minWidth: "100px" }}
                      size="large"
                      type="primary"
                      htmlType="submit"
                      loading={loading}
                    >
                      <FormattedMessage id="app.actions.send" />
                    </Button>
                  </Form.Item>
                </div>
              </Row>
            </Row>
          </ChildrenAnimationWrapper>
        </Form>
      </div>
    </Modal>
  );
};

export default SendMail;
